import axiosAuth from '../../axiosMain';

async function show(id) {
  let response = await axiosAuth.get('/category_dashboard_elements/' + id);
  return response.data.data;
}

export default {
  show,
};
